<template>
  <div class="content-wrapper  solutions">
    <a href="#"><img width="100%" src="images/solutions.jpg" alt=""/></a>

    <div class="b-solution-in">
      <breadcrumbs :items="breadcrumbs" />

      <h1 class="b-solution__name">Подвал</h1>
      <div class="b-solution__dots">
        <v-img
          class="b-solution__img"
          src="upload/iblock/84a/84aadb3c1f1670820ca1f190674b8194.jpg"
          alt=""
          :aspect-ratio="1.629"
        />
        <div data-id="1" class="b-solution__dot" style="top: 93%; left: 8%;">
          1
        </div>

        <div data-id="2" class="b-solution__dot" style="top: 91%; left: 14%;">
          2
        </div>

        <div data-id="3" class="b-solution__dot" style="top: 89%; left: 21%;">
          3
        </div>

        <div data-id="4" class="b-solution__dot" style="top: 85%; left: 28%;">
          4
        </div>

        <div data-id="5" class="b-solution__dot" style="top: 84%; left: 5%;">
          5
        </div>

        <div data-id="6" class="b-solution__dot" style="top: 80%; left: 40%;">
          6
        </div>

        <div data-id="7" class="b-solution__dot" style="top: 78%; left: 60%;">
          7
        </div>

        <div data-id="8" class="b-solution__dot" style="top: 57%; left: 54%;">
          8
        </div>

        <div data-id="9" class="b-solution__dot" style="top: 38%; left: 70%;">
          9
        </div>

        <div data-id="10" class="b-solution__dot" style="top: 26%; left: 77%;">
          10
        </div>

        <div data-id="11" class="b-solution__dot" style="top: 22%; left: 53%;">
          11
        </div>
      </div>

      <div class="b-solution__groups">
        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="1">
            <div class="b-solution__group-key">1</div>
            -
            <div class="b-solution__group-name">Стяжка</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a href="#">
                  <img
                    src="upload/iblock/c7f/c7f1ac79d5bca47a69e8a2cff1a9b60c.jpg"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a href="#">Sikafloor®-258 Screed Fiber</a>
                </div>
                <div class="b-solution__group-item-desc">
                  Армированная быстротвердеющая стяжка с толщиной нанесения до
                  80 мм
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="2">
            <div class="b-solution__group-key">2</div>
            -
            <div class="b-solution__group-name">Грунт</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a href="#">
                  <img
                    src="upload/iblock/3f3/3f3c893dfe490f78d2d8a26558428e6f.png"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a href="#">Sikafloor®-07 Primer Pro</a>
                </div>
                <div class="b-solution__group-item-desc">
                  Концентрат водно-дисперсионного универсального акрилового
                  грунта
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="3">
            <div class="b-solution__group-key">3</div>
            -
            <div class="b-solution__group-name">Наливной пол</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a href="#">
                  <img
                    src="https://sikahome.ru/upload/iblock/8b5/8b5715f7cbf29f3b14c1148ec96b325b.jpg"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a href="#">Sika® Level Pro</a>
                </div>
                <div class="b-solution__group-item-desc">
                  Высокопрочный быстротвердеющий наливной пол для финишного
                  выравнивания от 5 до 30 мм
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="4">
            <div class="b-solution__group-key">4</div>
            -
            <div class="b-solution__group-name">Цементная гидроизоляция</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a href="#">
                  <img
                    src="upload/iblock/d83/d83508a7ad31906821b0a89bd71dade0.jpg"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a href="#">Sika® TopSeal-107</a>
                </div>
                <div class="b-solution__group-item-desc">
                  Обмазочная цементная двухкомпонентная гидроизоляция для
                  бассейнов, подвалов и фундаментов
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="5">
            <div class="b-solution__group-key">5</div>
            -
            <div class="b-solution__group-name">Гидроизоляционная лента</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a href="#">
                  <img
                    src="upload/iblock/c56/c5606fb22c6025d8066f3c753b547a47.jpg"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a href="#">Sika® SealTape-S</a>
                </div>
                <div class="b-solution__group-item-desc">
                  Эластичная лента для гидроизоляции углов и примыканий
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="6">
            <div class="b-solution__group-key">6</div>
            -
            <div class="b-solution__group-name">Цементный плиточный клей</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a href="#">
                  <img
                    src="upload/iblock/ea0/ea08204c0e70b2f0893db1a0f4d58ed7.jpg"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a href="#">SikaCeram® Universal</a>
                </div>
                <div class="b-solution__group-item-desc">
                  Плиточный клей для внутренних и внешних работ. Класс С1 TE
                  &#40;ГОСТ Р 56387&#41;. Максимальный размер плитки 50х50<br />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="7">
            <div class="b-solution__group-key">7</div>
            -
            <div class="b-solution__group-name">Анкеровочный состав</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a href="#">
                  <img
                    src="upload/iblock/65e/65e518e205abe96c854ee61100e259d0.png"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a href="#">Sika® AnchorFix®-1</a>
                </div>
                <div class="b-solution__group-item-desc">
                  Быстротвердеющий анкеровочный состав
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="8">
            <div class="b-solution__group-key">8</div>
            -
            <div class="b-solution__group-name">Клей-герметик</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a href="#">
                  <img
                    src="upload/iblock/ef1/ef1fd365a872f521a2df995fd91595e3.png"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a href="#">Sikaflex®-11FC+ (i-Сure)</a>
                </div>
                <div class="b-solution__group-item-desc">
                  2 в 1. Универсальный цветной клей-герметик
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="9">
            <div class="b-solution__group-key">9</div>
            -
            <div class="b-solution__group-name">Финишное покрытие</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a href="#">
                  <img
                    src="upload/iblock/825/825dd6856f721ab0478eaf4eb6cdff28.png"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a href="#">Sikafloor®-2530 W</a>
                </div>
                <div class="b-solution__group-item-desc">
                  Паропроницаемое цветное окрасочное покрытие для пола на водной
                  основе
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="10">
            <div class="b-solution__group-key">10</div>
            -
            <div class="b-solution__group-name">Монтажный клей</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a href="#">
                  <img
                    src="upload/iblock/c30/c304de710bd7f0a8421c727600ce40f6.png"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a href="#">Sikaflex®-118 Extreme Grab</a>
                </div>
                <div class="b-solution__group-item-desc">
                  Клей для фиксации тяжёлых элементов
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="11">
            <div class="b-solution__group-key">11</div>
            -
            <div class="b-solution__group-name">Ремонтный состав</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a href="#">
                  <img
                    src="upload/iblock/137/1379130d017ebe7de0407a09012f432f.jpg"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a href="#">Sikadur®-31 CF Normal</a>
                </div>
                <div class="b-solution__group-item-desc">
                  Универсальный ремонтный состав
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p><a href="#"></a></p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadcrumbs: [
        {
          label: "Главная",
          to: { name: "main" },
        },
        {
          label: "Решения для дома",
          to: { name: "solutions" },
        },
        {
          label: "Подвал",
        },
      ],
    };
  },
};
</script>

<style lang="scss"></style>
